import { PreCadastroType } from '../../types/PreCadastro.types';
import { PreCadastroState } from '../../types/state.types';
import { ConfigsSet, getSessionConfig } from '../../utils/session-helper';
import { StoreAction } from '../reduxTypes';
import * as actions from './actions';

const hoje: Date = new Date();

const initialState: PreCadastroState = {
  dados: {
    ID: 0,
    nome: "",
    cpf: "",
    pispasep: "",
    sexoID: 0,
    estadoCivilID: 0,
    grauInstrucaoID: 0,
    dataNascimento: "",
    tipoSanguineoID: 0,
    regimeComunhaoID: 0,
    mae: "",
    pai: "",
    rg: "",
    dataExpedicaoRG: "",
    orgaoExpedidorID: 0,
    ufIDOrgaoExpedidor: "",
    tituloEleitor: "",

  // ENDEREÇO E CONTATO
    email: "",
    dddTelefoneCelular: "",
    telefoneCelular: "",
    dddTelefoneResidencial: "",
    telefoneResidencial: "",
    paisID: 0,
    ufID: undefined,
    cidadeID: 0,
    logradouro: "",
    numeroLogradouro: "",
    cep: "",
    complemento: "",
    bairro: "",
    nomeCidade: "",
    ufIDEndereco: "",

  // DADOS DE COOPERADO
    conselhoID: 0,
    numeroConselho: "",
    categoriaID: 0,
    especialidadeID: 0,
    cursoCooperativismo: false,

    dataAtendimento: "",
    dataAgendamento: "",
    horarioAgendamento: "",
  },
  listaCidades: [],
  dadosIniciais: undefined,
  listaDatasAtendimento: [],
  listaHorariosAtendimento: [],
  agendamentoAtual: false,
  agendamentoBuscado: false,
  concluido: false,
  estaCadastrado: false,
}

const preencherDados = (dados: any): PreCadastroType => {
  return {
    ID: dados.ID,
    nome: dados.nome || dados.Nome,
    cpf: dados.cpf || dados.CPF,
    pispasep: dados.pispasep || dados.PisPasep,
    sexoID: dados.sexoID || dados.SexoID,
    estadoCivilID: dados.estadoCivilID || dados.EstadoCivilID,
    grauInstrucaoID: dados.grauInstrucaoID || dados.GrauInstrucaoID,
    dataNascimento: dados.dataNascimento
    ? dados.dataNascimento.substring(0,10)
    : dados.DataNascimento
      ? dados.DataNascimento.substring(0,10)
      : '',
    tipoSanguineoID: dados.tipoSanguineoID || dados.TipoSanguineoID,
    regimeComunhaoID: dados.regimeComunhaoID || dados.RegimeComunhaoID,
    mae: dados.mae || dados.Mae,
    pai: dados.pai || dados.Pai,
    rg: dados.rg || dados.RG,
    dataExpedicaoRG: dados.dataExpedicaoRG
      ? dados.dataExpedicaoRG.substring(0,10)
      : dados.DataExpedicaoRG
        ? dados.DataExpedicaoRG.substring(0,10)
        : '',
    orgaoExpedidorID: dados.orgaoExpedidorID || dados.OrgaoExpedidorID,
    ufIDOrgaoExpedidor: dados.ufIDOrgaoExpedidor || dados.UfIDOrgaoExpedidor || dados.UFIDOrgaoExpedidor,
    tituloEleitor: dados.tituloEleitor || dados.TituloEleitor,

  // ENDEREÇO E CONTATO
    email: dados.email || dados.Email,
    dddTelefoneCelular: dados.dddTelefoneCelular
      ? dados.dddTelefoneCelular === '  ' ? '' : dados.dddTelefoneCelular
      : dados.DDDTelefoneCelular
        ? dados.DDDTelefoneCelular === '  ' ? '' : dados.DDDTelefoneCelular
        : '',
    telefoneCelular: dados.telefoneCelular || dados.TelefoneCelular,
    dddTelefoneResidencial: dados.dddTelefoneResidencial
      ? dados.dddTelefoneResidencial === '  ' ? '' : dados.dddTelefoneResidencial
      : dados.DDDTelefoneResidencial
        ? dados.DDDTelefoneResidencial === '  ' ? '' : dados.DDDTelefoneResidencial
        : '',
    telefoneResidencial: dados.telefoneResidencial || dados.TelefoneResidencial,
    paisID: dados.paisID || dados.PaisID,
    ufID: dados.ufID || dados.UFID || dados.UfID,
    cidadeID: dados.cidadeID || dados.CidadeID,
    logradouro: dados.logradouro || dados.Logradouro,
    numeroLogradouro: dados.numeroLogradouro || dados.NumeroLogradouro,
    cep: dados.cep
      ? (dados.cep as string).trim()
      : dados.CEP
        ? (dados.CEP as string).trim()
        : dados.Cep
          ? (dados.Cep as string).trim()
          : '',
    complemento: dados.complemento || dados.Complemento,
    bairro: dados.bairro || dados.Bairro,
    nomeCidade: dados.nomeCidade || dados.NomeCidade,
    ufIDEndereco: dados.ufIDEndereco || dados.UfIDEndereco || dados.UFIDEndereco,

  // DADOS DE COOPERADO
    conselhoID: dados.conselhoID || dados.ConselhoID,
    numeroConselho: dados.numeroConselho || dados.NumeroConselho,
    categoriaID: dados.categoriaID || dados.CategoriaID,
    especialidadeID: dados.especialidadeID || dados.EspecialidadeID,
    cursoCooperativismo: dados.cursoCooperativismo || dados.CursoCooperativismo,

    dataAtendimento: dados.dataAtendimento || dados.DataAtendimento,
    dataAgendamento: '',
    horarioAgendamento: '',
  };
}

const reducer = (
  state: PreCadastroState = initialState,
  action: StoreAction,
): PreCadastroState => {
  switch (action.type) {
    case actions.PRE_CADASTRO__INICIALIZA_ESTADO:
      return initialState;

    case actions.PRE_CADASTRO__SET_DADOS_INICIAIS:
      if (action.payload && action.payload.PisObrigatorio) {
        return {
          ...state,
          dadosIniciais: {...action.payload, PisObrigatorio: action.payload.PisObrigatorio ?? true},
        };
      }
      return {
        ...state,
        dadosIniciais: action.payload,
      };

    case actions.PRE_CADASTRO__SET_LISTA_CIDADES:
      return {
        ...state,
        listaCidades: action.payload,
      };

    case actions.PRE_CADASTRO__SET_DATAS_ATENDIMENTO:
      return {
        ...state,
        listaDatasAtendimento: action.payload,
      };

    case actions.PRE_CADASTRO__SET_HORARIOS_ATENDIMENTO:
      return {
        ...state,
        listaHorariosAtendimento: action.payload,
      };

    case actions.PRE_CADASTRO__SET_AGENDAMENTO_ATUAL:
      const dataAgendamentoAtual = action.payload
        ? action.payload.DataAtendimento
        : undefined;
        const possuiAgendamento = getSessionConfig()
          .Configuracoes
          ?.find(c => c.ID === ConfigsSet.AgendamentoPreCad)
          ?.Valor === '1';

      return {
        ...state,
        agendamentoAtual: !!action.payload,
        dados: action.payload ? preencherDados(action.payload) : state.dados,
        agendamentoBuscado: true,
        estaCadastrado: !!action.payload
        ? possuiAgendamento
          ? dataAgendamentoAtual
            ? Date.parse(dataAgendamentoAtual) < hoje.getTime()
            : false
          : true
        : false,
      };

    case actions.PRE_CADASTRO__SET_DADOS:
      return {
        ...state,
        dados: action.payload,
      };

    case actions.PRE_CADASTRO__LIMPAR_DADOS:
      return {
        ...state,
        dados: initialState.dados,
      };

    case actions.PRE_CADASTRO__CONCLUIR_CADASTRO:
      return {
        ...initialState,
        concluido: true,
      };

    case actions.PRE_CADASTRO__JA_CADASTRADO:
      return {
        ...initialState,
        estaCadastrado: true,
      };

    default:
      return state;
  }
}

export default reducer;
